import { render } from "./WebSearch.vue?vue&type=template&id=6f7141ea"
import script from "./WebSearch.vue?vue&type=script&lang=js"
export * from "./WebSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__